import { useDispatch } from 'react-redux';
import { telemetry } from '../../../../../telemetry';
import { useCallback } from 'react';
import { setTagsList } from '../../../../../reducers/documentation/userInputsReducer';
import { useUserInputsApiFacade } from '../../../../../apis/facades/useUserInputsApiFacade';

export const useFetchTags = () => {
  const dispatch = useDispatch();
  const { get_tags } = useUserInputsApiFacade();

  const fetchTags = useCallback(
    async (crmOrgId: string) => {
      try {
        const tags = await get_tags(crmOrgId);
        dispatch(setTagsList({ tags }));
      } catch (error) {
        telemetry.captureError(error);
      }
    },
    [get_tags, dispatch],
  );

  return fetchTags;
};
